import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Tab, Tabs } from '@mui/material';
import VehiclesPage from './VehiclesPage';
import VehicleMakesPage from './VehicleMakesPage';
import { resolveVehicleTab, type VehicleTab } from './vehicleTabs';

export default function VehicleTabsPage() {
  const { t } = useTranslation('vehicles');
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = resolveVehicleTab(searchParams.get('tab'));

  const handleTabChange = useCallback((_: React.SyntheticEvent, value: VehicleTab) => {
    // Built on top of the current params so the fleet's own ?filter= and ?id=
    // survive a trip to the make list and back.
    const next = new URLSearchParams(searchParams);
    // 'vehicles' is the default tab and carries no ?tab param so its URL stays clean.
    if (value === 'vehicles') {
      next.delete('tab');
    } else {
      next.set('tab', value);
    }
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab value="vehicles" label={t('tabs.vehicles')} />
        <Tab value="makes" label={t('tabs.makes')} />
      </Tabs>

      {activeTab === 'vehicles' && <VehiclesPage />}
      {activeTab === 'makes' && <VehicleMakesPage />}
    </Box>
  );
}
